import { IssueCommentResponse } from 'common-module/src/components/Epic/Model/comment';
import http from 'common-module/src/util/http';

export const getCommentList = async (
  issueId: number,
  projectId: number,
  field = 'create_time',
  order: 'desc' | 'asc' = 'desc'
): Promise<IssueCommentResponse> => {
  return http.post(
    '/sys-comment/issue/list-comment',
    {
      linkId: issueId,
      pageSize: 9999,
      pageNumber: 1,
      projectId,
      queryOrderBy: { field: field, desc: order === 'desc' }
    },
    {
      showError: false
    }
  );
};

export const markCommentMessageRead = async (reminderId: number): Promise<void> => {
  return http.post('/msg/mark-category-read', {
    id: reminderId
  });
};
